import React from 'react';
import { Link } from 'react-router-dom';

export default function CTA() {
    return (
        <section className="cta" id="cta">
            <div className="container">
                <div className="cta-content">
                    <h2>Prêt à transformer votre entreprise ?</h2>
                    <p>Parlons de votre projet et créons ensemble votre solution.</p>
                    <Link to="/contact" className="btn btn-primary btn-large">
                        Demander un devis
                    </Link>
                </div>
            </div>
        </section>
    );
}